import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Clipboard = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Clipboard' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,3 L21,3 L21,23 L3,23 L3,3 L3,3 L8,3 M8,1 L16,1 L16,6 L8,6 L8,1 Z' />
  </StyledIcon>
);
